import { createFileRoute } from "@tanstack/react-router";
import DealerMetaAds from "@/pages/DealerMetaAds";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/de/dealer-demo/")({
  head: () => routeHead("/de/dealer-demo/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <DealerMetaAds />
  );
}
